import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementJa from './element.ja'
import messageJa from './message.ja'
import enumJa from './enum.ja'
import elementEn from './element.en'
import messageEn from './message.en'
import enumEn from './enum.en'
import elementZh from './element.zh'
import messageZh from './message.zh'
import enumZh from './enum.zh'

Vue.use(VueI18n)

const messages = {
  ja: {
    ...messageJa,
    ...elementJa,
    ...enumJa,
  },
  en: {
    ...messageEn,
    ...elementEn,
    ...enumEn,
  },
  zh: {
    ...messageZh,
    ...elementZh,
    ...enumZh,
  },
}

const i18n = new VueI18n({
  locale: navigator.language.split('-')[0], 
  fallbackLocale: 'en',
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn:true
  // formatFallbackMessages:true
})

export default i18n